// extracted by mini-css-extract-plugin
export default {"panel":"loading-panel_panel__UCnmY","loader":"loading-panel_loader__STkuJ"};